module.exports = __webpack_public_path__ + "img/Gynécologue.052c1fc8.png";